export default {
    prescriptionSelected: null,
  };
  